/**
 * formDeriveIdOfRowId
 *
 * The INVERSE of `formDeriveProjectionRowId`: the deriveId a projected row id
 * claims, or `null` when the id is outside the `drv~` namespace or carries no
 * second `~`. Consumers: the reconciler's in-pass orphan test and the repair
 * sweep's `drv~`-range walk — both of which DELETE on this answer, which is why
 * mint and parse live in one directory rather than one per tree.
 *
 * The segment is parseable because `createFormDeriveEngineConfig` validates
 * deriveIds free of `~`, and the TRAILING separator is load-bearing: without it
 * deriveId `ab` would claim `drv~abc~1`'s rows. Takes a plain `string` because
 * callers hold raw document ids.
 */

import { FORM_DERIVE_ROW_ID_PREFIX } from '../System.FormDerive.types';
import type { FormDeriveId } from '../System.FormDerive.types';

function formDeriveIdOfRowId(rowId: string): FormDeriveId | null {
  if (!rowId.startsWith(FORM_DERIVE_ROW_ID_PREFIX)) return null;
  const rest = rowId.slice(FORM_DERIVE_ROW_ID_PREFIX.length);
  const separator = rest.indexOf('~');
  return separator === -1 ? null : rest.slice(0, separator);
}

export { formDeriveIdOfRowId };
